<template>
  <b-modal
    :visible="value"
    title="Negative Feedback"
    ok-only
    ok-title="Close"
    @change="$emit('input', $event)"
  >
    <div v-if="loading" class="text-center py-4">
      <b-spinner></b-spinner>
    </div>
    <div v-else-if="feedback" class="feedback-detail">
      <div class="feedback-detail-row">
        <span class="feedback-detail-label">Customer</span>
        <span>{{ feedback.name || 'Not provided' }}</span>
      </div>
      <div v-if="feedback.email" class="feedback-detail-row">
        <span class="feedback-detail-label">Email</span>
        <a :href="'mailto:' + feedback.email">{{ feedback.email }}</a>
      </div>
      <div class="feedback-detail-row">
        <span class="feedback-detail-label">Rating</span>
        <span v-if="feedback.rating">
          <span class="feedback-stars">{{ '★'.repeat(feedback.rating) }}</span><span class="feedback-stars-empty">{{ '★'.repeat(5 - feedback.rating) }}</span>
          {{ feedback.rating }} out of 5
        </span>
        <span v-else>Negative experience</span>
      </div>
      <div class="feedback-detail-row">
        <span class="feedback-detail-label">Received</span>
        <span>{{ feedback.front_date }}</span>
      </div>
      <div class="feedback-detail-label mt-3 mb-1">Feedback</div>
      <div class="feedback-detail-text">{{ feedback.feedback }}</div>
    </div>
    <div v-else class="text-muted">This feedback could not be found.</div>
  </b-modal>
</template>

<script>
export default {
  name: 'FeedbackDetailModal',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    feedback: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.feedback-detail-row {
  display: flex;
  gap: 12px;
  padding: 6px 0;
  border-bottom: 1px solid #f1f5f9;
}

.feedback-detail-label {
  width: 90px;
  flex-shrink: 0;
  font-weight: 600;
  color: #374151;
}

.feedback-detail-text {
  white-space: pre-wrap;
  word-wrap: break-word;
  border-left: 4px solid #e85f5f;
  background: #fdf2f2;
  padding: 12px 16px;
  color: #374151;
}

.feedback-stars {
  color: #ffb400;
}

.feedback-stars-empty {
  color: #d1d5db;
}
</style>
